// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Neu5","spinner-border":"Spinner_spinner-border__3vwTn"};